import * as React from "react"
import '../scss/header.scss'
import { Link, navigate } from "gatsby"
import { useState, useEffect } from 'react'
import Icon from "../images/icons/Icon"
import MenuIcon from "../images/icons/MenuIcon"
import Close from "../images/icons/Close"
import Arrow from "../images/icons/Arrow"
import companies_area from '../images/area_buttons/companies_mobile.svg'
import education_area from '../images/area_buttons/school_mobile.svg'
import social_area from '../images/area_buttons/social_mobile.svg'
const menu_options = [
  {
    label: 'home',
    path: '/'
  },
  {
    label: 'playroom',
    path: 'https://playroom.narratividigitali.com/'
  },
  {
    label: 'blog',
    path: '/blog'
  },
  {
    label: 'contattaci',
    path: '/contacts'
  }
]

const HeaderTop = ({ white_header, menuOpen, toggleMenu, small }: {
  white_header?: boolean,
  menuOpen: boolean,
  toggleMenu: () => any,
  small: boolean
}) => {

  const [floating, setFloating] = useState(false)

  const handleScroll = () => {

    if (small) {
      return;
    }
    const position = window.pageYOffset;
    if (position > 40) {
      setFloating(true)
    } else if (position < 10) {
      setFloating(false)
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return <div className={"Header__Content"
    + (floating ? ' Header__Content--floating primary-border-bottom' : ' Header__Content--not-floating')
    + (menuOpen ? ' Header__Content--menuOpen primary-border' : '')
  } >
    <div className={"Header__TopBar"} >
      <div
        className="Header__Icon"
      >
        <Link to="/" aria-label="Go to home">
          {
            white_header && !menuOpen && !floating ?
              <Icon className="white-fill" /> :
              <Icon className="primary-fill" />
          }
        </Link>
      </div>
      <div
        className="Header__Spacer"
      >
      </div>
      <div
        className="Header__Menu"
      >
        {menu_options.map(option => <Link
          key={option.label}
          className={"Header__MenuItem "
            + ((white_header && !floating) ? "Header__MenuItem--white " : "primary-color")}
          to={option.path}
        >{option.label}</Link>)}

      </div>
      <div
        className="Header__MenuMobile"
      >
        <button
          className="Header__MenuButton"
          onClick={toggleMenu}
        >
          {
            !menuOpen ?
              <>
                {(!white_header || floating) ?
                  <MenuIcon className="primary-fill" /> :
                  <MenuIcon className="white-fill" />}
              </> :
              <Close className="primary-fill" />
          }
        </button>
      </div>
    </div>

  </div>
}

const MobileMenu = ({ menuOpen, closeMenu }: {
  menuOpen: boolean,
  closeMenu: () => any
}) => {
  const navigate_to = (path: string) => {

    navigate(path)

    closeMenu()
  }
  return <div className={menuOpen ? "primary-border-color Header__MobileMenu Header__MobileMenu--opened" : "Header__MobileMenu Header__MobileMenu--closed"}>
    <div className="Header__MobileMenuContainer">
      <div className="Header__MobileMenuOptionContainer">
        <button className="Header__MobileMenuOption primary-color" onClick={() => {
          navigate_to('/')
        }}>home <Arrow
            className="primary-fill"
            style={{ marginTop: 8 }}
          />
        </button>
      </div>
      <div className="Header__MobileMenuOptionContainer">
        <button className="Header__MobileMenuOption primary-color" onClick={() => {
          navigate_to('https://playroom.narratividigitali.com/')
        }}>Playroom<Arrow
            className="primary-fill"
            style={{ marginTop: 8 }}
          />
        </button>
      </div>
      <div className="Header__MobileMenuOptionContainer">
        <button className="Header__MobileMenuOption primary-color" onClick={() => {
          navigate_to('/blog')
        }}>blog <Arrow
            className="primary-fill"
            style={{ marginTop: 8 }}
          />
        </button>
      </div>
      <div className="Header__MobileMenuOptionContainer">
        <button className="Header__MobileMenuOption primary-color" onClick={() => {
          navigate_to('/contacts')
        }}>contattaci <Arrow
            className="primary-fill"
            style={{ marginTop: 8 }}
          />
        </button>
      </div>
      {/* <div className="Header__MobileAreas">
        <Link
          className="Header__MobileAreasLink"
          to="/aziende"
        >
          <img src={companies_area} alt="Per le aziende" />
        </Link>
        <Link
          className="Header__MobileAreasLink"
          to="/scuole"
        >
          <img src={education_area} alt="Per le scuole" />
        </Link>
        <Link
          className="Header__MobileAreasLink"
          to="/sociale"
        >
          <img src={social_area} alt="Per il sociale" />
        </Link>
      </div> */}
    </div>
  </div>
}

const Header = ({
  banner,
  white_header,
  small,
  no_border
}: {
  banner?: any,
  white_header?: boolean,
  small?: boolean,
  no_border?: boolean
}) => {
  const [menuOpen, setMenuOpen] = useState(false)
  const toggleMenu = () => {
    if (!menuOpen) {
      document.body.classList.add("not-scroll")
    } else {
      document.body.classList.remove("not-scroll")
    }
    setMenuOpen(!menuOpen)
  }

  const closeMenu = () => {
    toggleMenu()
  }

  return <header
    className={"Header__Container "
      + (white_header ? '' : 'primary-background-color ')
      + (small ? 'Header__Container--small ' : '')}
  >
    <HeaderTop
      white_header={white_header}
      menuOpen={menuOpen}
      toggleMenu={toggleMenu}
      small={small!}
    />
    <div className={`Header__Banner ${no_border ? '' : 'primary-border-color'}`}>
      {banner}
      <MobileMenu
        menuOpen={menuOpen}
        closeMenu={closeMenu}
      />
    </div>
  </header>
}

export default Header